import { formatINR } from "../../lib/format";
import { cn as classJoin } from "../../lib/utils";

export default function TrendChart({ months, series, accent }) {
    const max = Math.max(1, ...series.map((s) => s.value || 0));
    const total = series.reduce((a, s) => a + (s.value || 0), 0);
    return (
        <div className="reedos-card p-4" data-testid={`trend-${accent.key}`}>
            <div className="flex items-center justify-between mb-3">
                <div>
                    <div className="reedos-eyebrow flex items-center gap-1.5">{accent.icon} {accent.label}</div>
                    <div className="text-[11px] text-slate-500 mt-0.5">12-month rolling · monthly</div>
                </div>
                <div className="text-right">
                    <div className="reedos-eyebrow text-[9px]">Window total</div>
                    <div className="reedos-data text-sm font-bold text-slate-900">{formatINR(total)}</div>
                </div>
            </div>
            <div className="grid grid-cols-12 gap-1.5 items-end h-20">
                {series.map((s, i) => {
                    const heightPct = max > 0 ? (s.value || 0) / max * 100 : 0;
                    return (
                        <div key={s.month} className="flex flex-col items-center justify-end" title={`${months[i]}: ${formatINR(s.value)} (${s.count})`}>
                            <div className={classJoin("w-full rounded-t transition-colors", accent.barClass)} style={{ height: `${Math.max(2, heightPct)}%`, minHeight: 2 }} />
                        </div>
                    );
                })}
            </div>
            <div className="grid grid-cols-12 gap-1 mt-1.5">
                {months.map((m) => (
                    <div key={m} className="text-[8px] text-slate-400 text-center font-mono truncate">{m.slice(2).replace("-", "/")}</div>
                ))}
            </div>
        </div>
    );
}
